import React from "react";
import { Icon } from "semantic-ui-react";
import ScfoButton from "src/components/shared/ScfoButton";

/**
 * Maps legacy Semantic UI Button props to ScfoButton variants.
 * Note: SUI color="red" was themed as salmon globally; this wrapper maps red → danger (true destructive).
 */
function semanticPropsToVariant({ primary, secondary, color }) {
  if (primary) return "primary";
  if (secondary) return "secondary";
  const c = color;
  if (c === "blue" || c === "primary") return "primary";
  if (c === "red" || c === "negative") return "danger";
  if (c === "green" || c === "positive") return "success";
  if (c === "teal") return "secondary";
  return "primary";
}

/**
 * Previene doble-click en handlers async (cooldown + ejecución única).
 * Compatibilidad: content, icon, labelPosition, color, primary, etc.
 */
export default function AsyncButton({
  onClick,
  disabled = false,
  loading = false,
  cooldownMs = 500,
  disableOnLoading = true,
  children,
  content,
  primary,
  secondary,
  color,
  icon,
  labelPosition,
  className,
  style,
  id,
  type = "button",
}) {
  const variant = semanticPropsToVariant({ primary, secondary, color });

  const label = children ?? content;
  const showIconLeft = icon && labelPosition === "left";
  const showIconRight = icon && labelPosition !== "left";

  return (
    <ScfoButton
      type={type}
      id={id}
      className={className}
      style={style}
      variant={variant}
      disabled={disabled}
      loading={loading}
      async
      cooldownMs={cooldownMs}
      disableOnLoading={disableOnLoading}
      onClick={onClick}
    >
      {showIconLeft ? <Icon name={icon} /> : null}
      {label}
      {showIconRight ? <Icon name={icon} /> : null}
    </ScfoButton>
  );
}
